"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getData = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var fontData2_sidecar_1 = require("@uiParts/fontData2-sidecar");
var _data = null;
var getData = function () {
    if (!_data) {
        var alphaLower = 'abcdefghijklmnopqrstuvwxyz';
        var alphaUpper = alphaLower.toUpperCase();
        var extra = "1234567890.!?/:,+-%()*'$_";
        var font4 = fontData2_sidecar_1.fontData2.create('font-4', {
            charSpacing: 1,
            charWidth: 3,
            charHeight: 6,
            data: [
                {
                    chars: alphaUpper,
                    sprite: sprites_sidecar_1.sprites.goatFont41,
                },
                {
                    chars: extra,
                    sprite: sprites_sidecar_1.sprites.goatFont42,
                },
            ],
        });
        // Adjust widths
        fontData2_sidecar_1.fontData2.setWidths(font4, 'mw', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font4, 'nx', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font4, 'q', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font4, '?', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font4, '%', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font4, '*', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font4, '/', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font4, '1:', 1, -2);
        fontData2_sidecar_1.fontData2.setWidths(font4, ':', 1, -2);
        //fontData2.setWidths(font4, '.', 2, -1)
        fontData2_sidecar_1.fontData2.setWidths(font4, '.', 1, -2);
        var font6 = fontData2_sidecar_1.fontData2.create('font-62', {
            charSpacing: 1,
            charWidth: 3,
            charHeight: 8,
            data: [
                {
                    chars: alphaUpper,
                    sprite: sprites_sidecar_1.sprites.goatFont621,
                },
                {
                    chars: alphaLower,
                    sprite: sprites_sidecar_1.sprites.goatFont622,
                },
                {
                    chars: extra,
                    sprite: sprites_sidecar_1.sprites.goatFont623,
                },
            ],
        });
        // Adjust widths
        fontData2_sidecar_1.fontData2.setWidths(font6, 'MZ', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'NY', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'X', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'Q', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'W', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'F', 3, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'e', 3, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'a', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'sf', 2, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'u', 3, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'il', 1, -1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'mw', 5, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'z', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'n', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'y', 3, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'x', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, 'q', 3, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, '?', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, '%', 4, 1);
        fontData2_sidecar_1.fontData2.setWidths(font6, '/', 4, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, '1', 1, -2);
        fontData2_sidecar_1.fontData2.setWidths(font6, ':', 2, -1);
        fontData2_sidecar_1.fontData2.setWidths(font6, '.', 2, -1, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, '!', 2, -1, 0);
        fontData2_sidecar_1.fontData2.setWidths(font6, ',', 2, -1, 2);
        fontData2_sidecar_1.fontData2.setWidths(font6, "'", 1, -1, 0);
        _data = {
            font4: font4,
            font6: font6,
            alphaLower: alphaLower,
            alphaUpper: alphaUpper,
            extra: extra,
        };
    }
    return _data;
};
exports.getData = getData;
